<template>
    <div class="page-sportsbook container" v-if="isEnabled">
        <div id="altenarsportsbook"/>
    </div>
</template>

<script>
import sportsbookConfig from "../../../../../../../config/sportsbook";
import {loadScript} from '../../../../../../../src/util/load-script';
import eventsInterface from "../../../../../../../src/interfaces/eventsInterface";

export default {
    name: "AltenarSportsbook",

    data: function () {
        return {
            title: undefined,
        }
    },

    mounted() {
        this.$store.commit('SET_APP_CLASS', 'sportsbetting');
        this.title = document.title;

        loadScript(sportsbookConfig.altenar.scriptUrl, 'altenarsportsbookscript')
            .then(() => this.initSportsbook())
            .catch((error) => {
                if (error.target) {
                    return console.error(
                        `[vue-matomo] An error occurred trying to load ${error.target.src}. ` +
                        'If the file exists you may have an ad- or trackingblocker enabled.'
                    )
                }

                console.error(error);
            })
    },

    watch: {
        user() {
            this.updateSportsbook();
        },
    },

    computed: {
        user() {
            return this.$store.state.user;
        },

        locale() {
            return this.$store.state.locale;
        },

        isEnabled() {
            return sportsbookConfig.altenar.isEnabled;
        },
    },

    methods: {
        initSportsbook() {
            let self = this,
                token = this.user && this.user.sessionKey,
                integration = sportsbookConfig.altenar.integration,
                themeName = sportsbookConfig.altenar.themeName,
                appLocale = this.$store.state.appLocale,
                culture = sportsbookConfig.altenar.languageMapping[appLocale.languageCountryCode] || appLocale.languageCountryCode;

            if (window.altenarWSDK) {
                let options = {
                    integration: integration,
                    culture: culture,
                    token: token,
                }

                if (themeName) {
                    options['themeName'] = themeName
                }

                window.altenarWSDK.init(options)

                window.ASB = window.altenarWSDK.addSportsBook({
                    props: {
                        onSignInButtonClick: () => {
                            this.$store.commit('OPEN_LOGIN_DIALOG');
                        },
                        onRouteChangeDetailed: (state) => {
                            self.translateTitle(state.page);
                            window.scrollTo(0, 0);
                        },
                        onBetPlacement: (params) => {
                            if (typeof params != "object") {
                                params = [];
                            }

                            void require('../../../../../../../src/util/analytics/index').trackEvent(eventsInterface.playGame, this, {
                                user: self.user,
                                location: 'Betting',
                                mode: 'bet',
                                game: {
                                    id: params || [],
                                    title: 'Sports betting',
                                    vendorProviderCode: 'Altenar',
                                }
                            });
                        }
                    },
                    container: document.getElementById('altenarsportsbook'),
                })
            }
        },

        translateTitle(title = '') {
            let titleKey = 'front.sportsbook.page.' + title;
            let translatedTitle = this.$t(titleKey);

            title = translatedTitle !== titleKey ? translatedTitle : title.charAt(0).toUpperCase() + title.slice(1);
            document.title = title + ' - ' + this.title;
        },

        updateSportsbook() {
            if (window.altenarWSDK) {
                let token = this.user && this.user.sessionKey;

                window.altenarWSDK.set({
                    token: token,
                })
            }
        },
    },

    beforeDestroy() {
        if (window.ASB) {
            window.ASB.remove()
        }

        this.$store.commit('SET_APP_CLASS', '');
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/AltenarSportsbook"
</style>
